/**
 * Drag the Words layout normalization (question-set–like defaults).
 */

import type { QtDragTheWordsLayoutConfig } from './schema';

export type QtDragTheWordsPanelArrangement = 'horizontal' | 'vertical';

export function normalizeQtDragTheWordsPanelArrangement(
    raw: string | undefined,
): QtDragTheWordsPanelArrangement {
    if (raw === 'vertical') {
        return 'vertical';
    }
    return 'horizontal';
}

export function normalizeQtDragTheWordsLayoutConfig(
    layout: QtDragTheWordsLayoutConfig | undefined | null,
): QtDragTheWordsLayoutConfig & { type: QtDragTheWordsPanelArrangement } {
    const base = (layout ?? {}) as Partial<QtDragTheWordsLayoutConfig>;
    const type = normalizeQtDragTheWordsPanelArrangement(base.type as string | undefined);
    return {
        ...(base as QtDragTheWordsLayoutConfig),
        type,
    };
}
